import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiCall, formatDay } from "../utils/apiCall";

// The missions a member has led, for self-evaluation: each mission's date, school,
// status and the feedback given. A member sees their own on their profile; admins
// and super admins see anyone's on the member's page. The API decides who may see it.
function MissionsLed({ userId, title = "Missions led" }) {
    const [data, setData] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!userId) return undefined;
        let cancelled = false;

        apiCall(`/users/${userId}/missions-led`)
            .then(({ ok, data: result }) => {
                if (cancelled) return;
                if (ok) setData(result);
                else setError("The missions could not be loaded.");
            })
            .catch(() => !cancelled && setError("The missions could not be loaded."));

        return () => {
            cancelled = true;
        };
    }, [userId]);

    const summary = data?.summary;
    const missions = data?.missions || [];

    return (
        <div className="box cf-history">
            <p className="title is-5">{title}</p>

            {error && <p className="cf-muted">{error}</p>}
            {!data && !error && <p className="cf-muted">Loading...</p>}

            {summary && summary.total > 0 && (
                <dl className="cf-history-facts">
                    <div><dt>Missions led</dt><dd>{summary.total}{summary.upcoming > 0 ? ` (${summary.upcoming} to come)` : ""}</dd></div>
                    <div><dt>Feedback sent</dt><dd>{summary.feedback_given} of {summary.completed}</dd></div>
                    <div><dt>Feedback still due</dt><dd>{summary.feedback_due}</dd></div>
                    <div><dt>Converts reported</dt><dd>{summary.total_converts}</dd></div>
                    <div>
                        <dt>Feedback sent after</dt>
                        <dd>{summary.average_days_to_feedback != null ? `${summary.average_days_to_feedback} days on average` : "-"}</dd>
                    </div>
                </dl>
            )}

            {data && missions.length === 0 && <p className="cf-muted">No missions led yet.</p>}

            {missions.length > 0 && (
                <div className="table-container">
                    <table className="table is-fullwidth is-striped">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>School</th>
                                <th>Mission</th>
                                <th>Status</th>
                                <th>Feedback</th>
                                <th>Converts</th>
                                <th>Missioners present</th>
                            </tr>
                        </thead>
                        <tbody>
                            {missions.map((m) => (
                                <tr key={m.id}>
                                    <td className="cf-nowrap">{formatDay(m.start_date)}</td>
                                    <td><Link to={`/dashboard/missions/${m.id}/details`}>{m.school_name || m.name}</Link></td>
                                    <td>{m.mission_type || "-"}</td>
                                    <td>{m.is_past || String(m.status).toLowerCase() !== "active" ? m.status : "Coming up"}</td>
                                    <td>
                                        {m.feedback_given && (
                                            <span className="cf-badge is-ok">
                                                Sent{m.feedback_days_after != null ? `, ${m.feedback_days_after === 0 ? "same day" : `${m.feedback_days_after} day${m.feedback_days_after === 1 ? "" : "s"} after`}` : ""}
                                            </span>
                                        )}
                                        {m.feedback_due && (
                                            <Link className="cf-badge is-bad" to={`/dashboard/missions/${m.id}/feedback`}>Due</Link>
                                        )}
                                        {!m.feedback_given && !m.feedback_due && <span className="cf-muted">-</span>}
                                    </td>
                                    <td>{m.no_of_converts ?? "-"}</td>
                                    <td>{m.no_of_missioners_present ?? "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default MissionsLed;
